$(document).on("click", ".favorite-actions", function(e){
  e.preventDefault()
  var product_id = $(this).data("product-id")
  var token = $("input[name=_token]").val()

  $.ajax({
    url: $(this).attr('href'),
    data: {
      product_id: product_id,
      _token: token
    },
    dataType: "json",
    type: "post",
    success: function(data){
      if (data.code == "added") {
        $(".favorite-actions").html(data.text)
      }else if (data.code == "removed") {
        $(".favorite-actions").html(data.text)
      }
    },
    error: function(data){
      $(".login-modal").click()
    }
  })
})
